import { FoodCard } from '@screens/HomePage/PlantVirusPage/FoodCard';

interface RelatedFoodsProps {
  foods: Array<{
    id: number;
    name: string;
    image_url: string;
    rank: string;
  }>;
}

export const RelatedFoods = ({ foods }: RelatedFoodsProps) => {
  return (
    <div className="space-y-4">
      <h2 className="typography-h1 text-primary">Related Foods</h2>
      <div className="grid grid-cols-1 md:grid-cols-2 gap-2">
        {foods.map((food) => (
          <FoodCard
          key={food.id}
          id={food.id}
          name={food.name}
          imageUrl={food.image_url}
          rank={food.rank as 'Superfood' | 'Minimize' | 'Avoid'}
        />
        ))}
      </div>
    </div>
  );
};